import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-success.png'


const _withScopeId = n => (_pushScopeId("data-v-4c850764"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-self-recycling-form-submitted"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "tips" }
const _hoisted_5 = { class: "tips" }

import { computed } from 'vue';
  import { ColorVariants } from '@/constants';
  import { useI18n } from 'vue-i18n';
  import { ColletionBinStore } from '@/stores';
  import { useRoute, useRouter } from 'vue-router';
  import { IOfflineCollection } from '@/types/offline-collection';

  interface IProps {
    collectionBinStore: ColletionBinStore;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    collectionBinStore: null
  },
  setup(__props: any) {

const props = __props as {
    collectionBinStore: ColletionBinStore;
  }

  
  const { t } = useI18n();

  const route = useRoute();
  const userRequestId = Number(route.params.userRequestId);
  if (!props.collectionBinStore.userRequest) {
    props.collectionBinStore.fetchUserRequest(userRequestId);
  }

  const router = useRouter();
  async function handleRequestReward() {
    await props.collectionBinStore.requestReward(userRequestId);
    router.replace({ name: 'offline_collections.bin.request_reward_finish', params: { userRequestId } });
  }

  function goHome() {
    router.replace({ name: 'home' });
  }

  const limitationMethod = computed(() => {
    const { limitation_method } = props.collectionBinStore.data.target as IOfflineCollection;
    return limitation_method;
  });

  const remainingNumber = computed(() => {
    if (props.collectionBinStore.userInfo.remaining_number_of_barcodes === null) {
      return null;
    }
    return Number(route.params.remainingNumberOfBarcodes) || props.collectionBinStore.userInfo.remaining_number_of_barcodes;
  });

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (__props.collectionBinStore.userRequest)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, [
          (_unref(remainingNumber) === null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_unref(t)('well_done_not_limited')), 1)
              ], 64))
            : (_unref(remainingNumber) !== 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_unref(limitationMethod) === 'per_campaign')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(t)('can_submit_for_campaign', { num: _unref(remainingNumber) })), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(limitationMethod) === 'per_day')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(t)('can_submit_today', { num: _unref(remainingNumber) })), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('oc_tips')), 1),
        (__props.collectionBinStore.userRequest?.can_request_oc_reward && _unref(remainingNumber) !== 0)
          ? (_openBlock(), _createBlock(_component_b_button, {
              key: 0,
              class: "btn-request",
              pill: "",
              variant: _unref(ColorVariants).outlinePrimary,
              onClick: handleRequestReward
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('offline_collection.request_reward')), 1)
              ]),
              _: 1
            }, 8, ["variant"]))
          : (_openBlock(), _createBlock(_component_b_button, {
              key: 1,
              class: "btn-request",
              pill: "",
              variant: _unref(ColorVariants).outlinePrimary,
              onClick: goHome
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('offline_collection.back_to_home_page')), 1)
              ]),
              _: 1
            }, 8, ["variant"]))
      ]))
    : _createCommentVNode("", true)
}
}

})